<section class="bill-history">
  <header>
    <div><span class="eyebrow">Saved bills</span><h1>Bills<span>.</span></h1><p>Your saved receipts and their split results.</p></div>
    <button type="button" (click)="refresh()" [disabled]="loading()">{{ loading() ? 'Loading…' : 'Refresh' }}</button>
  </header>
  @if (error()) { <p class="alert" role="alert">{{ error() }}</p> }
  @if (loading() && !bills().length) { <p class="empty">Loading saved bills…</p> }
  @else if (bills().length) {
    <div class="table-wrap"><table>
      <thead><tr><th>Merchant</th><th>Date</th><th>Split with</th><th>Items</th><th>Total</th><th>Original file</th><th><span class="visually-hidden">Actions</span></th></tr></thead>
      <tbody>@for (bill of bills(); track bill.id) {
        <tr tabindex="0" (click)="openBill(bill.id)" (keydown.enter)="openBillFromKeyboard($event, bill.id)">
          <td>{{ bill.merchant || 'Untitled bill' }}</td><td>{{ bill.date || '—' }}</td><td class="people">{{ bill.people.length ? bill.people.join(', ') : '—' }}</td><td>{{ bill.itemCount }}</td>
          <td>{{ bill.total / 100 | currency:bill.currency }}</td><td>
            @if (bill.sourcePath && bill.sourceFileName) {
              <button type="button" class="file-link" (click)="openSource($event, bill)" [attr.aria-label]="'Open original ' + sourceKind(bill) + ' file: ' + bill.sourceFileName" [title]="'Open original ' + bill.sourceFileName">
                <svg class="file-icon" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
                  @switch (sourceKind(bill)) {
                    @case ('image') { <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5z" /><circle cx="8.5" cy="8.5" r="1.25" /><path d="m5 18 4.5-4.5 3 3L15.5 13 19 16.5" /> }
                    @case ('pdf') { <path d="M7 3.5h7l3 3v14H7z" /><path d="M14 3.5v4h4M9.5 14h5M9.5 17h3" /> }
                    @case ('text') { <path d="M7 3.5h7l3 3v14H7z" /><path d="M14 3.5v4h4M9.5 12h5M9.5 15h5M9.5 18h3" /> }
                    @default { <path d="M7 3.5h7l3 3v14H7z" /><path d="M14 3.5v4h4M9.5 13h5M9.5 16h5" /> }
                  }
                </svg>
                <span>{{ bill.sourceFileName }}</span>
              </button>
            }
            @else { — }
          </td>
          <td class="actions"><button type="button" class="delete-button" (click)="deleteBill($event, bill)" [disabled]="deletingBillIds().has(bill.id)" [attr.aria-label]="'Delete ' + (bill.merchant || 'bill')" title="Delete bill">
            <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V4.5h6V7M7 7l.8 12.5h8.4L17 7M10 11v5M14 11v5" /></svg>
          </button></td>
        </tr>
      }</tbody>
    </table></div>
  } @else if (!error()) { <p class="empty">No saved bills yet. Import a receipt, then choose Save bill.</p> }
</section>
